export type ListPrice = {
  currency: string;
  value: number;
}
export class Price {
  constructor(
    public listPrice: ListPrice
  ) {}
}
